import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../Constants/routes';
import ReactPlayer from "react-player"

export default class Features extends Component {
    render() {
        return (
            <div className="cover-container d-flex h-100 p-3 mx-auto flex-column">
                <header className="masthead mb-auto">
                    <div className="inner">
                        <h3 className="masthead-brand">Conver.ai</h3>
                        <nav className="nav nav-masthead justify-content-center">
                            <Link className="nav-link " to={ROUTES.HOME}>Home</Link>
                            <Link className="nav-link active" to={ROUTES.FEATURES}>Features</Link>
                            <Link className="nav-link" to={ROUTES.PRIVACYPOLICY}>Privacy Policy</Link>
                        </nav>
                    </div>
                </header>


                <h1 className="cover-heading mb-5 mt-3 text-center">Features</h1>
                {/* <p className="lead">
                    <a href="#" className="btn btn-lg btn-secondary">Learn more</a>
                </p> */}
                <div className="mx-auto text-center" style={{ height: "100%", }}>
                    <ReactPlayer playing={true} loop={true} controls={true} width={600} height={337.2}
                        url="https://www.youtube.com/watch?v=6UNwUrhsQ9U"
                    />
                </div>

                <p className="lead policy-heading mt-4"><strong>Artificial intelligence to detect prices</strong></p>

                <p>
                    We use AI to detect prices in our apps camera feed for faster detection and to improve user experience
                  </p>

                <p>
                    Detection guess list for the user to choose from when the AI detects multiple possible numbers
                  </p>

                <p>
                    Currency convertion rates updated daily to give the user the most accurate result
                  </p>

                <p>
                    Recently used history giving the user the last 3 coverted prices
                  </p>

                  <p>
                    Over 30 most commonly used currency rates
                  </p>

                  <p className="lead policy-heading mt-4"><strong>Offline detection</strong></p>

                  <p>
                    With the full feature package comes offline mode, which allows the user to use the app offline anywhere. 
                    App will use current currency rates when the offline mode was activated
                  </p>
            </div>
        )
    }
}
